import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { TableOptions } from "../../../../shared-kernel/components/Table";
import {
  createAdapterToIncomeCollection,
  createAdapterToIncomeCollectionEndpoint,
  createAdapterToFieldIncomeCollectionEndpoint,
} from "../adapters/incomeCollection.adapter";
import {
  EndpointIncomeCollectionFiltered,
  IncomeCollection,
  IncomeCollectionEndpoint,
} from "../domain/IncomeCollection.model";
import { appConfig } from "../../../../config";
import { createAdapterToFilterBackend } from "../../../../utilities/paramsAdapter";

const BASE_INCOMECOLLECTION_URL = "/estimaciones/cobros";
const BASE_INCOMECOLLECTION_BY_ID_URL = "/estimaciones/cobros/ingreso";


export const incomeCollectionApi = createApi({
  reducerPath: "incomeCollectionApi",
  baseQuery: fetchBaseQuery({
    baseUrl: appConfig.API_NODE_URL,
    prepareHeaders: (headers: Headers) => {
      const APP_TOKEN = "app_token";
      const token = localStorage.getItem(APP_TOKEN);

      if (token) {
        headers.set("authorization", `${token}`);
      }

      return headers;
    },
    credentials: "include",
  }),
  refetchOnMountOrArgChange: true,
  tagTypes: ["IncomeCollections", "OwnCheques", "ThirdPartyCheques"],
  endpoints: (builder) => ({
    getIncomeCollection: builder.query<IncomeCollection[], number | undefined>({
      query: (id) => `${BASE_INCOMECOLLECTION_BY_ID_URL}/${id}`,
      transformResponse: (
        response: IncomeCollectionEndpoint[],
        _meta,
      ) => {
        return response.map((e: IncomeCollectionEndpoint) =>
          createAdapterToIncomeCollection(e)
        );
      },
    }),
    getIncomeCollections: builder.query<any, TableOptions<IncomeCollection> | undefined>({
      query: (params: TableOptions<IncomeCollection>) => {
        const { page, pageSize, order, search, filters } = params || {};
        const adaptersFilter = filters?.map((f) =>
          createAdapterToFilterBackend(
            f,
            createAdapterToFieldIncomeCollectionEndpoint
          )
        );
        const serializedFilters = adaptersFilter
          ? JSON.stringify(adaptersFilter)
          : undefined;
        const serializedOrder = order
          ? JSON.stringify({
              field: createAdapterToFieldIncomeCollectionEndpoint(order.field),
              order: order.order,
            })
          : undefined;
        return {
          url: `${BASE_INCOMECOLLECTION_URL}/filtros`,
          params: {
            page: page ? page - 1 : 0,
            pageSize,
            order: serializedOrder,
            search,
            filters: serializedFilters,
          },
        };
      },
      providesTags: ["IncomeCollections"],
      transformResponse: (
        response: EndpointIncomeCollectionFiltered,
        _meta,
        params: TableOptions<IncomeCollection>
      ) => {
        const page = params?.page ?? 1;
        const endpointResponse = response?.rows?.map(
          (customer: IncomeCollectionEndpoint) =>
            createAdapterToIncomeCollection(customer)
        );
        return {
          data: endpointResponse,
          page,
          total: response.total,
        };
      },
    }),
    createIncomeCollection: builder.mutation<any, {data:IncomeCollection[], id:number}>({
      query: ({ data, id }) => ({
        url: `${BASE_INCOMECOLLECTION_URL}/list/${id}`,
        method: "POST",
        body: {cobros: data.map((i) => createAdapterToIncomeCollectionEndpoint(i))}
      }),
      invalidatesTags: ["IncomeCollections", "OwnCheques", "ThirdPartyCheques"],
    }),
  }),
});

export const {
  useGetIncomeCollectionQuery,
  useGetIncomeCollectionsQuery,
  useCreateIncomeCollectionMutation,
} = incomeCollectionApi;
